import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای ورود دسته‌جمعی موجودی اولیه

اگر می‌خواهید موجودی اولیه انبار را به صورت دسته‌جمعی و از طریق فایل اکسل وارد کنید، از این قسمت استفاده نمایید.

## ۱. آماده‌سازی فایل
اطلاعات پالت‌ها، مقادیر، و انبارهای مربوطه را در قالب فایل اکسل وارد کنید.

## ۲. پردازش و ثبت
با آپلود فایل، سیستم رکوردها را پردازش کرده و در صورت عدم وجود خطا، موجودی پالت‌ها را در انبارها شارژ می‌کند.

export default Layout;
